import { noop } from "@common/helpers/function";
import { createContext, useContext } from "react";

export interface CashFlowExpandContextValue {
    expandedRowIds: Set<string>;
    isAllCollapsed: boolean;
    expandAll: () => void;
    collapseAll: () => void;
    toggleExpand: (rowId: string) => void;
}

export const CashFlowExpandContext = createContext<CashFlowExpandContextValue>({
    expandedRowIds: new Set(),
    isAllCollapsed: true,
    expandAll: noop,
    collapseAll: noop,
    toggleExpand: noop,
});

export function useCashFlowExpandContext(): CashFlowExpandContextValue {
    const ctx = useContext(CashFlowExpandContext);
    if (!ctx) {
        throw new Error("Can only be used inside a CashFlowExpandProvider");
    }

    return ctx;
}
